import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CbmContext from '../Context/Cbm/cbmContext';
import './SubmissionSuccess.css';

function SubmissionSuccess() {
  const navigate = useNavigate();
  const cbmContext = useContext(CbmContext);
  const {
    resetSubmissionStates,
    submitStatus,
    submitFailed,
    submitSuccess,
    successMessage,
    lastSubmissionEmailStatus,
  } = cbmContext;
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    if (
      submitFailed !== false ||
      submitStatus !== false ||
      submitSuccess !== false
    ) {
      resetSubmissionStates();
    }
  }, [resetSubmissionStates, submitFailed, submitStatus, submitSuccess]);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="success-page">
      <div className="success-container">
        {/* Success Icon with Animation */}
        <div className="success-icon-wrapper">
          <div className="success-checkmark">
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark-circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark-check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </div>
        </div>

        {/* Success Message */}
        <h1 className="success-title">Submission Successful!</h1>
        <p className="success-message">
          {successMessage ||
            'Your form has been submitted successfully and is being processed.'}
        </p>
        <p className="success-message">
          A secure link has been emailed to the recipient. Attachments are no
          longer sent for routine delivery.
        </p>

        {/* Details Card */}
        <div className="success-details">
          <div className="detail-item">
            <span className="detail-icon">✓</span>
            <div className="detail-content">
              <div className="detail-label">Status</div>
              <div className="detail-value">Submitted</div>
            </div>
          </div>
          <div className="detail-item">
            <span className="detail-icon">📅</span>
            <div className="detail-content">
              <div className="detail-label">Date</div>
              <div className="detail-value">
                {new Date().toLocaleDateString()}
              </div>
            </div>
          </div>
          <div className="detail-item">
            <span className="detail-icon">⏰</span>
            <div className="detail-content">
              <div className="detail-label">Time</div>
              <div className="detail-value">
                {new Date().toLocaleTimeString()}
              </div>
            </div>
          </div>
          {lastSubmissionEmailStatus && (
            <div className="detail-item">
              <span className="detail-icon">
                {lastSubmissionEmailStatus === 'SENT'
                  ? '✉️'
                  : lastSubmissionEmailStatus === 'FAILED'
                  ? '⚠️'
                  : '⏳'}
              </span>
              <div className="detail-content">
                <div className="detail-label">Email Notification</div>
                <div
                  className={`detail-value ${
                    lastSubmissionEmailStatus === 'FAILED'
                      ? 'detail-value-warning'
                      : ''
                  }`}
                >
                  {lastSubmissionEmailStatus === 'SENT' &&
                    'Email sent successfully'}
                  {lastSubmissionEmailStatus === 'FAILED' &&
                    'Email delivery failed — an admin can resend it'}
                  {lastSubmissionEmailStatus === 'PENDING' && 'Email pending'}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* What's Next Section */}
        <div className="next-steps">
          <h3>What happens next?</h3>
          <ul>
            <li>
              Your submission will be reviewed by the appropriate personnel
            </li>
            <li>
              You will be notified if any additional information is needed
            </li>
            <li>Processing typically takes 1-3 business days</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="success-actions">
          <button className="btn-primary" onClick={handleGoHome}>
            Return to Home
          </button>
          <div className="countdown-text">
            Redirecting in {countdown} seconds...
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubmissionSuccess;
